import React from 'react';
import { Definition, Property } from '../../../data/Definition';
import { ChartProvider } from '../ChartProvider';
import StatsTimeSeriesForm from './StatsTimeSeriesForm';
import { DwQuery, IDimension, IDwFilter, IMeasure } from '../../../data/Query';
import DataFrame from 'dataframe-js';
import DefaultChartLayout from '../DefPlotLayout';
import { StatsTimeSeriesDataProvider } from '../../../data/dataProviders';
import { StatsTimeSeriesConfigManager } from './StatsTimeSeriesConfigManager';
import { ChartConfigManager } from '../ChartConfigManager';

export class StatsTimeSeriesChartProvider extends ChartProvider {
    private onParentSaveConfig: any = null;

    constructor() {
        super('Statistics Time Series');

        this.onSaveConfig = this.onSaveConfig.bind(this);
    }

    getConfigForm(definition: Definition, chartConfig: any, onSaveConfig: any) {
        this.onParentSaveConfig = onSaveConfig;

        return (
            <StatsTimeSeriesForm definition={definition} config={chartConfig} saveConfig={this.onSaveConfig} />
        );
    }

    configManager(definition: Definition) : ChartConfigManager {
        return new StatsTimeSeriesConfigManager(definition);
    }

    getQuery(definition: Definition, chartConfig: any): null | DwQuery {
        const configManager = new StatsTimeSeriesConfigManager(definition);

        if (!configManager.validate(chartConfig)) {
            chartConfig = configManager.convert(configManager);
        }

        const query = super.getQuery(definition, chartConfig);
        query!.timeSeries = true;

        console.log('time series config', chartConfig, query);

        return query;
    }

    filterFromSelection(definition: Definition, chartConfig: any, selection: any): IDwFilter[] | null {

        const xProp = chartConfig.dimension[1].source.item as Property;
        const yProp = chartConfig.measure[0].source.item as Property;

        console.log('yProp', xProp, yProp, selection.range.y, selection.range.x);

        return [
            {
                type: "property",
                id: `${this.getPath(definition, chartConfig.dimension[1].source.item)}[${chartConfig.dimension[1].source.sub}]`,
                name: xProp.property,
                operation: "between",
                value: selection.range.x
            },
            {
                type: "property",
                id: `${this.getPath(definition, chartConfig.measure[0].source.item)}[${chartConfig.measure[0].source.sub}]`,
                name: yProp.property,
                operation: "between",
                value: selection.range.y
            },
        ];
    }

    getPlotly(definition: Definition, chartConfig: any, data: any): {} {
        // use the default layout and update the items for the given chart type.
        // make a deep copy.
        //
        let layout: any = JSON.parse(JSON.stringify(DefaultChartLayout));

        const {rows} = data;

        if (!rows || rows.length === 0) {
            return {
                data: [],
                layout: layout
            };
        }

        const groupDimension: IDimension = chartConfig.dimension[0];
        const dateDimension: IDimension = chartConfig.dimension[1];
        const measure: IMeasure = chartConfig.measure[0];

        const df = this.dataToDataFrame(rows);
        const dataProvider = new StatsTimeSeriesDataProvider(groupDimension, dateDimension, measure, df);

         // each row in the df is an entity or group.
         const dimensionField = `${groupDimension.source.item!.name}_name`;
        
         // modified to handle response from dw for state properties
         const measureProp = measure.source.item as Property;
         const dateDimensionProp = dateDimension.source.item as Property;
         const measureValueField = `${measureProp.property}_${measure.source.sub}`;
         const measureDateField = `${dateDimensionProp.property}_${dateDimension.bin}`;
        
        const traces: any[] = [];

        df.toCollection(true).forEach((row:any) => {
            var trace = {
                mode: "lines",
                name: `${row.get(dimensionField)}`,
                x: row.get(measureDateField),
                y: row.get(measureValueField)
            };

            traces.push(trace);
        });

        if (chartConfig.dimension[1].bin === 'year') {
            layout.xaxis.tickformat = '%Y';
        } else if (chartConfig.dimension[1].bin === 'month') {
            layout.xaxis.tickformat = '%B %Y';
        }

        layout.xaxis.title = dataProvider.dimensionTitle();
        layout.yaxis.title = dataProvider.measureTitle();

        layout.xaxis = {
            title: dataProvider.dimensionTitle(),
            autorange: true,
            rangeslider: {},
            type: 'date'
          }

        return {
            data: traces,
            layout: layout
        };
    }

    dataToDataFrame(data: any) {
        let rows: any[] = [];
        data.forEach((d: any) => {
            let row: any[] = [];

            Object.keys(d).forEach((key: any) => {
                row.push(d[key]);
            });

            rows.push(row);
        });

        let header: string[] = [];
        Object.keys(data[0]).forEach((key: any) => {
            header.push(key);
        });

        return new DataFrame(rows, header);
    }

    onSaveConfig(chartConfig: any) {
        this.onParentSaveConfig(chartConfig);
    }
}
